import { ReactElement } from 'react';
import {
  Grid,
  Typography,
  Box,
  Divider,
  Container,
  Stack,
  SvgIcon,
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Formik } from 'formik';
import {
  AppPrimaryButton,
  AppSecondaryButton,
  AppPrimaryButtonOutlined,
  AppSecondaryButtonOutlined,
  AppTeritaryButton,
  AppFormikTextField,
  AppFormikTextArea,
  AppFormikPasswordField,
  AppCheckBox,
  AppFormikSelect,
  AppCheckBoxDefault,
  AppCheckBoxOutline,
  AppFormikButtonStateTiles,
} from './AppComponents';

import { ReactComponent as AssessmIcon } from 'assets/images/assessm_template.svg';
import { ReactComponent as InventoryIcon } from 'assets/images/ic_inventory.svg';
import { ReactComponent as ApproversIcon } from 'assets/images/ic_approvers.svg';
import { ReactComponent as AuditReadiness } from 'assets/images/ic_audit_readiness.svg';
import { ReactComponent as Dashboard } from 'assets/images/ic_dashboard.svg';
import { ReactComponent as Data } from 'assets/images/ic_data.svg';
import { ReactComponent as Discovery } from 'assets/images/ic_discovery.svg';
import { ReactComponent as EnterprisePortal } from 'assets/images/ic_enterprise_portal.svg';
import { ReactComponent as Incidents } from 'assets/images/ic_incidents.svg';
import { ReactComponent as Maturity } from 'assets/images/ic_maturity.svg';
import { ReactComponent as Overview } from 'assets/images/ic_overview.svg';
import { ReactComponent as PoliciesManagem } from 'assets/images/ic_policies_managem.svg';
import { ReactComponent as Policies } from 'assets/images/ic_policies.svg';
import { ReactComponent as Register } from 'assets/images/ic_register.svg';
import { ReactComponent as RiskAssessm } from 'assets/images/ic_risk_assessm.svg';
import { ReactComponent as RiskMan } from 'assets/images/ic_risk_man.svg';
import { ReactComponent as TrainingProgram } from 'assets/images/ic_training_program.svg';
import { ReactComponent as Training } from 'assets/images/ic_training.svg';
import { ReactComponent as Vulnerab } from 'assets/images/ic_vulnerab.svg';
import { ReactComponent as IconSettings } from 'assets/images/icon_settings.svg';
import { ReactComponent as Logout } from 'assets/images/logout.svg';
import { ReactComponent as Sensitive } from 'assets/images/sensitive.svg';
import { ReactComponent as System } from 'assets/images/ic_system.svg';
import { ReactComponent as Connections } from 'assets/images/ic_connections.svg';
import { ReactComponent as Github } from 'assets/images/ic_github.svg';
import { ReactComponent as HuggingFace } from 'assets/images/ic_hugging_face.svg';
import { ReactComponent as VertexAI } from 'assets/images/ic_vertexAI.svg';
import { ReactComponent as CopilotStudio } from 'assets/images/ic_copilot_studio.svg';
import { ReactComponent as Okta } from 'assets/images/ic_okta.svg';
import { ReactComponent as Defender } from 'assets/images/ic_defender.svg';
import { ReactComponent as RequestConnection } from 'assets/images/ic_request_connect.svg';
import { ReactComponent as Calender } from 'assets/images/ic_calender.svg';
import { ReactComponent as Flag } from 'assets/images/ic_flag.svg';

const DesignBook = (): ReactElement => (
  // UI Elements
  <Container maxWidth="md">
    <Grid id="design-book" container>
      <Grid item xs={12}>
        <Box my={2}>
          <Typography variant="h4">Typography</Typography>
          <Divider />
        </Box>
        <Typography variant="h1">Heading H1</Typography>
        <Typography variant="h2">Heading H2</Typography>
        <Typography variant="h3">Heading h3</Typography>
        <Typography variant="h4">Heading h4</Typography>
        <Typography variant="h5">Heading h5</Typography>
        <Typography variant="h6">Heading h6</Typography>
        <Typography variant="body1">Body 1</Typography>
        <Typography variant="body2">Body 2</Typography>
        <Typography variant="caption">Caption</Typography>
      </Grid>
      <Grid item xs={12}>
        <Box mt={2}>
          <Box my={2}>
            <Typography variant="h2">Text Field</Typography>
            <Divider />
          </Box>
          <Formik
            initialValues={{
              smallInput: 'Small Input',
              placeholderInput: '',
              largeInput: '',
              password: '',
              multiLine: 'Multiline',
              readOnly: 'Read only',
            }}
            enableReinitialize
            onSubmit={() => {
              // console.log('');
            }}
          >
            {() => (
              <Grid item xs={12}>
                <AppFormikTextField
                  name="smallInput"
                  label="Small Input"
                  size="small"
                />

                <AppFormikTextField
                  name="placeholderInput"
                  label="Small Input"
                  placeholder="Input here"
                  size="small"
                  outerLabel
                />
                <AppFormikTextField
                  name="largeInput"
                  label="Large Input"
                  placeholder="Input here"
                  size="medium"
                />
                <AppFormikTextField
                  name="readOnly"
                  label="Read only"
                  size="medium"
                  readOnly
                />
                <AppFormikPasswordField
                  outerLabel
                  label="Current Password"
                  placeholder="Enter your current password"
                  name="password"
                />
                <AppFormikTextArea
                  name="multiLine"
                  label="Multi Line"
                  rows={4}
                />
              </Grid>
            )}
          </Formik>
        </Box>
        <Box mt={2}>
          <Box my={2}>
            <Typography variant="h3">Buttons</Typography>
            <Divider />
          </Box>
          <Typography variant="h4">Primary Button</Typography>
          <AppPrimaryButton title="Primary Button" />
          <AppPrimaryButton title="Primary Button" isLoading />
          <AppPrimaryButton title="Primary Button" isLoading disabled />
          <AppPrimaryButton
            title="Primary Button With Icon"
            endIcon={<ArrowForwardIosIcon />}
          />
          <AppPrimaryButton title="Small Button" className="btn-small" />
          <AppPrimaryButton
            title="Small Button"
            className="btn-small"
            endIcon={<ArrowForwardIosIcon />}
          />

          <AppPrimaryButton
            title="Extra Small Button"
            className="btn-extra-small"
          />
          <AppPrimaryButton
            title="Extra Small Button"
            className="btn-extra-small"
            isLoading
          />

          <AppPrimaryButton title="Primary Button" disabled />
        </Box>

        <Typography variant="h4">Primary Button Outlined</Typography>
        <AppPrimaryButtonOutlined title="Primary Button Outlined" />
        <AppPrimaryButtonOutlined title="Primary Button Outlined" isLoading />
        <AppPrimaryButtonOutlined
          title="Primary Button Outlined With Icon"
          endIcon={<ArrowForwardIosIcon />}
        />
        <AppPrimaryButtonOutlined title="Small Button" className="btn-small" />
        <AppPrimaryButtonOutlined
          title="Small Button"
          className="btn-small"
          endIcon={<ArrowForwardIosIcon />}
        />
        <AppPrimaryButtonOutlined
          title="Extra Small Button"
          className="btn-extra-small"
        />
        <AppPrimaryButtonOutlined
          title="Extra Small Button"
          className="btn-extra-small"
          isLoading
        />
        <AppPrimaryButtonOutlined title="Primary Button Outlined" disabled />

        <Box mt={2}>
          <Typography variant="h4">Secondary Button</Typography>
          <AppSecondaryButton title="Secondary Button" />
          <AppSecondaryButton title="Secondary Button" isLoading />
          <AppSecondaryButton
            title="Secondary Button With Icon"
            endIcon={<ArrowForwardIosIcon />}
          />
          <AppSecondaryButton title="Small Button" className="btn-small" />
          <AppSecondaryButton
            title="Small Button"
            className="btn-small"
            endIcon={<ArrowForwardIosIcon />}
          />
          <AppSecondaryButton
            title="Extra Small Button"
            className="btn-extra-small"
          />
          <AppSecondaryButton
            title="Extra Small Button"
            className="btn-extra-small"
            isLoading
          />
          <AppSecondaryButton
            disabled
            title="Disabled Button"
            className="btn-small"
            endIcon={<ArrowForwardIosIcon />}
          />
        </Box>

        <Box mt={2}>
          <Typography variant="h4">Secondary Button Outlined</Typography>
          <AppSecondaryButtonOutlined title="Secondary Button Outlined" />
          <AppSecondaryButtonOutlined
            title="Secondary Button Outlined"
            isLoading
          />
          <AppSecondaryButtonOutlined
            title="Secondary Button Outlined With Icon"
            endIcon={<ArrowForwardIosIcon />}
          />
          <AppSecondaryButtonOutlined
            title="Small Button"
            className="btn-small"
          />
          <AppSecondaryButtonOutlined
            title="Small Button"
            className="btn-small"
            endIcon={<ArrowForwardIosIcon />}
          />
          <AppSecondaryButtonOutlined
            title="Extra Small Button"
            className="btn-extra-small"
          />
          <AppSecondaryButtonOutlined
            title="Extra Small Button"
            className="btn-extra-small"
            isLoading
          />
          <AppSecondaryButtonOutlined
            title="Secondary Button Outlined"
            disabled
          />
        </Box>

        <Box mt={2}>
          <Typography variant="h4">Teritary Button</Typography>
          <AppTeritaryButton title="Teritary Button" />
          <AppTeritaryButton title="Teritary Button" isLoading />
          <AppTeritaryButton
            title="Teritary Button With Icon"
            endIcon={<ArrowForwardIosIcon />}
          />
          <AppTeritaryButton title="Small Button" className="btn-small" />
          <AppTeritaryButton
            title="Small Button"
            className="btn-small"
            endIcon={<ArrowForwardIosIcon />}
          />
          <AppTeritaryButton
            title="Extra Small Button"
            className="btn-extra-small"
          />
          <AppTeritaryButton
            title="Extra Small Button"
            className="btn-extra-small"
            isLoading
          />
          <AppTeritaryButton title="Teritary Button" disabled />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box mt={2}>
          <Typography variant="h4">Icons</Typography>
          <Stack spacing={3} direction="row" padding={2}>
            <SvgIcon
              component={AssessmIcon}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={InventoryIcon}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={ApproversIcon}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={AuditReadiness}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={Dashboard}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={Data}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={Discovery}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={EnterprisePortal}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={Incidents}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={Maturity}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
          </Stack>
          <Stack mt={3} spacing={3} direction="row" padding={2}>
            <SvgIcon
              component={Overview}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={PoliciesManagem}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={Policies}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={Register}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={RiskAssessm}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={RiskMan}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={TrainingProgram}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={Training}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={Vulnerab}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={IconSettings}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={Logout}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={Sensitive}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
            <SvgIcon
              component={System}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
            />
          </Stack>
          <Stack
            mt={3}
            spacing={3}
            direction="row"
            sx={{
              backgroundColor: '#313131',
              paddingTop: 5,
              paddingBottom: 5,
              paddingLeft: 2,
            }}
          >
            <SvgIcon
              component={Connections}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="white"
            />
            <SvgIcon
              component={Github}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="white"
            />
            <SvgIcon
              component={HuggingFace}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="white"
            />
            <SvgIcon
              component={VertexAI}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="white"
            />
            <SvgIcon
              component={CopilotStudio}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="white"
            />
            <SvgIcon
              component={Okta}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="white"
            />
            <SvgIcon
              component={Defender}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="white"
            />
            <SvgIcon
              component={RequestConnection}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="white"
            />
          </Stack>
          <Stack
            mt={3}
            spacing={3}
            direction="row"
            sx={{
              paddingTop: 2,
              paddingBottom: 2,
              paddingLeft: 2,
            }}
          >
            <SvgIcon
              component={Connections}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="#76A81F"
            />
            <SvgIcon
              component={Github}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="#76A81F"
            />
            <SvgIcon
              component={HuggingFace}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="#76A81F"
            />
            <SvgIcon
              component={VertexAI}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="#76A81F"
            />
            <SvgIcon
              component={CopilotStudio}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="#76A81F"
            />
            <SvgIcon
              component={Okta}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="#76A81F"
            />
            <SvgIcon
              component={Defender}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="#76A81F"
            />
            <SvgIcon
              component={RequestConnection}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="#76A81F"
            />
            <SvgIcon
              component={Calender}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="#3D3C42"
            />
            <SvgIcon
              component={Flag}
              inheritViewBox
              className="iconButtonImage"
              fontSize="inherit"
              htmlColor="#76A81F"
            />
          </Stack>
        </Box>
        <Box mt={2}>
          <Typography variant="h4">Checkbox</Typography>
          <Stack direction="row">
            <AppCheckBox checked={false} />
            <AppCheckBox checked />
          </Stack>

          <Stack direction="row">
            <AppCheckBoxDefault checked={false} />
            <AppCheckBoxDefault checked />
          </Stack>
          <Stack direction="row">
            <AppCheckBoxOutline checked={false} />
            <AppCheckBoxOutline checked />
          </Stack>
        </Box>
        <Box mt={2}>
          <Typography variant="h4">Switch Button</Typography>
          <Formik
            enableReinitialize
            initialValues={{ status: [false, true] }}
            validateOnMount
            onSubmit={() => console.log('test')}
          >
            {({ setFieldValue }) => (
              <AppFormikButtonStateTiles
                variant="outlined"
                name="status"
                size="small"
                label="Status"
                multichoice={false}
                className="button-tiles-status"
                buttons={[
                  {
                    value: 'Enable',
                    onClick: (e: any) => {
                      if (e.target.classList.contains('MuiButtonBase-root')) {
                        if (e.target.classList.contains('selected')) {
                          setFieldValue('status', [false, true]);
                        }
                      } else {
                        const DomList: DOMTokenList =
                          e.target.offsetParent.classList;

                        if (DomList.contains('selected')) {
                          setFieldValue('status', [false, true]);
                        }
                      }
                    },
                  },
                  {
                    value: 'Disable',
                    onClick: (e: any) => {
                      if (e.target.classList.contains('MuiButtonBase-root')) {
                        if (e.target.classList.contains('selected')) {
                          setFieldValue('status', [false, true]);
                        }
                      } else {
                        const DomList: DOMTokenList =
                          e.target.offsetParent.classList;

                        if (DomList.contains('selected')) {
                          setFieldValue('status', [true, false]);
                        }
                      }
                    },
                  },
                ]}
                outerLabel
              />
            )}
          </Formik>
        </Box>
        <Box mt={2}>
          <Typography variant="h4">Selection</Typography>
          <Formik
            initialValues={{
              isReworkModal: true,

              solicitor: '',
            }}
            onSubmit={() => console.log('test')}
          >
            <AppFormikSelect
              name="solicitor"
              className="rework-selection"
              notched={false}
              labelId="fix-selection-label"
              testid="solicitor-dropdown"
              MenuProps={{
                className: 'menu-fix-selection single-fix-rework',
              }}
              outerLabel
              placeholder="Select"
              notEmphasized
              notSelectablePlaceholder
              label="Solicitor"
              items={['test', 'bbb']}
            />
          </Formik>
        </Box>
      </Grid>
    </Grid>
  </Container>
);
export default DesignBook;
